import axios from 'axios';
import config from '../config/config';

class CompanyApi {
    static loadCompanies() {
        return axios.get(`${config.server.endpoint}backend/companies`)
    }

    static createCompany(name, shortName, street, streetNumber, zipcode, city, mail, phone, taxNumber, contactPerson) {
        return axios.post(`${config.server.endpoint}backend/company`, {
            name,
            shortName,
            street,
            streetNumber,
            zipcode,
            city,
            mail,
            phone,
            taxNumber,
            contactPerson
        });
    }

    static getCompany(id) {
        return axios.get(`${config.server.endpoint}backend/company/${id}`)
    }

    static updateCompany(id, name, shortName, street, streetNumber, zipcode, city, mail, phone, taxNumber, contactPerson) {
        return axios.put(`${config.server.endpoint}backend/company/${id}`, {
            name,
            shortName,
            street,
            streetNumber,
            zipcode,
            city,
            mail,
            phone,
            taxNumber,
            contactPerson
        });
    }

    static addCompanyToProject(id) {
        return axios.post(`${config.server.endpoint}backend/company/${id}/project`)
    }

    static removeCompanyFromProject(id) {
        return axios.delete(`${config.server.endpoint}backend/company/${id}/project`)
    }

    static createCompanyProjectQuota(id, workType, amount, amountUnlimited, pay, nightStart, nightEnd, nightExtra, sundayExtra, bankHolidayExtra) {
        return axios.post(`${config.server.endpoint}backend/company/companyProject/${id}/quota`, {
            workType,
            amount,
            amountUnlimited,
            pay,
            nightStart,
            nightEnd,
            nightExtra,
            sundayExtra,
            bankHolidayExtra
        });
    }

    static updateCompanyProjectQuota(id, workType, amount, amountUnlimited, pay, nightStart, nightEnd, nightExtra, sundayExtra, bankHolidayExtra) {
        return axios.put(`${config.server.endpoint}backend/company/companyProject/quota/${id}`, {
            workType,
            amount,
            amountUnlimited,
            pay,
            nightStart,
            nightEnd,
            nightExtra,
            sundayExtra,
            bankHolidayExtra
        });
    }

    static deleteCompanyProjectQuota(id) {
        return axios.delete(`${config.server.endpoint}backend/company/companyProject/quota/${id}`)
    }
}

export default CompanyApi;
